export function getToCResetPasswordUrl(_: { authKey: string }) {
  return '';
}
